import * as React from 'react';

function SvgIconAlertWarning(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#icon-alert-warning_svg__a)">
        <path
          d="M7 .875a6.125 6.125 0 100 12.25A6.125 6.125 0 007 .876zm-.438 3.172c0-.06.05-.11.11-.11h.656c.06 0 .11.05.11.11v3.719a.11.11 0 01-.11.109h-.656a.11.11 0 01-.11-.11V4.048zM7 10.063A.656.656 0 017 8.75a.656.656 0 010 1.313z"
          fill="#F9A600"
        />
      </g>
      <defs>
        <clipPath id="icon-alert-warning_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgIconAlertWarning;
